/* eslint-disable max-len */
/**
 * This is basically just a place to keep copy for updating error messages, etc.
 * There are lots of places the same error might pop up, so it's best to be
 * able to proof and update them in one spot.
 */

import Env from './Env';

export const getSupportLink = () => '<a href="https://service.amplify.com/s/support" target="_blank" rel="noopener noreferrer" data-dd-action-name="contact-support">contact customer support</a>';

export const UNAVAILABLE_MESSAGE = 'unavailable';
export const UNLICENSED_MESSAGE = 'unlicensed';
export const UNLICENSED_TEACHER_MESSAGE = 'unlicensed_teacher';
export const NO_MCLASS_GRADE_MESSAGE = 'no_mclass_grade';
export const NO_ONBOARDING_GRADE_MESSAGE = 'no_onboarding_grade';
export const NO_ONBOARDING_GRADE_SELF_ENROLLED_MESSAGE = 'no_onboarding_grade_self_enrolled';
export const NO_ONBOARDING_SCHOOL_YEAR_MESSAGE = 'no_onboarding_district_school_year';
export const SOMETHING_WENT_WRONG = 'something_went_wrong';
export const NO_STUDENT_ACCESS = 'no_student_access';
export const UNAUTHORIZED_SHARED_LOGIN = 'unauthorized_shared_login';
export const MAINTENANCE = 'maintenance';
export const NETWORK_ERROR_MESSAGE = 'network_error';
export const SUCCESS_MESSAGE = 'success';

export const MESSAGE_HEADERS = {
  [UNAVAILABLE_MESSAGE]: 'Boost Reading is currently unavailable.',
  [UNLICENSED_MESSAGE]: 'Ask your teacher!',
  [UNLICENSED_TEACHER_MESSAGE]: 'Uh oh!',
  [NO_MCLASS_GRADE_MESSAGE]: 'Ask your teacher!',
  [NO_ONBOARDING_GRADE_MESSAGE]: 'Ask your teacher!',
  [NO_ONBOARDING_GRADE_SELF_ENROLLED_MESSAGE]: 'Ask your teacher!',
  [NO_ONBOARDING_SCHOOL_YEAR_MESSAGE]: 'Ask your teacher!',
  [SOMETHING_WENT_WRONG]: 'Uh oh!',
  [NO_STUDENT_ACCESS]: 'Ask your teacher!',
  [UNAUTHORIZED_SHARED_LOGIN]: 'Shared Login is not currently supported for this App.',
  [MAINTENANCE]: "We're Sorry...",
  [NETWORK_ERROR_MESSAGE]: 'Uh oh!',
};

export const MESSAGE_COPY = {
  [UNAVAILABLE_MESSAGE]: 'We are working to restore service as soon as possible.',
  [UNLICENSED_MESSAGE]: `Looks like you aren't set up for Boost Reading. Please ${getSupportLink()} or call (800) 823-1969 to get set up.`,
  [UNLICENSED_TEACHER_MESSAGE]: `Something went wrong. Please ${getSupportLink()} or call (800) 823-1969.`,
  [NO_MCLASS_GRADE_MESSAGE]: `We don't have enough information to get started. Please ${getSupportLink()} or call (800) 823-1969 to get set up.`,
  [NO_ONBOARDING_GRADE_MESSAGE]: `We don't have enough information to get started. Please ${getSupportLink()} or call (800) 823-1969 to get set up.`,
  [NO_ONBOARDING_GRADE_SELF_ENROLLED_MESSAGE]: 'This student is missing grade and we are unsure where to send them. Please log in to the Teacher Dashboard for additional information.',
  [NO_ONBOARDING_SCHOOL_YEAR_MESSAGE]: 'This account is missing data. Please log in to the Teacher Dashboard for additional information.',
  [SOMETHING_WENT_WRONG]: 'Something went wrong.',
  [NO_STUDENT_ACCESS]: 'Students can\'t log in here. Try one of our student login methods instead.',
  [UNAUTHORIZED_SHARED_LOGIN]: `Please ${getSupportLink()} or call (800) 823-1969.`,
  [MAINTENANCE]: `Boost Reading is down for maintenance. Check the <a href=${Env.STATUS_URL}>status page</a> for updates.`,
  [NETWORK_ERROR_MESSAGE]: 'A network error has occurred. Please try again later.',
};

export default {
  UNAVAILABLE_MESSAGE,
  UNLICENSED_MESSAGE,
  UNLICENSED_TEACHER_MESSAGE,
  NO_MCLASS_GRADE_MESSAGE,
  NO_ONBOARDING_GRADE_MESSAGE,
  NO_ONBOARDING_GRADE_SELF_ENROLLED_MESSAGE,
  NO_ONBOARDING_SCHOOL_YEAR_MESSAGE,
  SOMETHING_WENT_WRONG,
  NO_STUDENT_ACCESS,
  UNAUTHORIZED_SHARED_LOGIN,
  MAINTENANCE,
  NETWORK_ERROR_MESSAGE,
};
